import {
    SET_COLUMNS
} from '../actions';

export function filteredColumns(state = [], action = {}) {
    return action.type === SET_COLUMNS ? Object.assign([], action.payload) : state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducers-filter-columns.js